import { apiCall, createApiThunk } from '../../../utils/api';
import { getBnySatBaseUrl } from '../../../services/apiService';

export const getAuditTrailThunk = createApiThunk('GET_AUDIT_TRAIL', apiCall);

export const getAuditTrail = (swapId: string) => (dispatch: AppDispatch) => {
  const url = `${getBnySatBaseUrl()}/v1/bny/trades/${swapId}/activities`;
  return dispatch(getAuditTrailThunk({ url, method: 'GET' }));
};
